import styled from "styled-components";

export const BtnActivityActionFormWidgetStyled = styled.div`
  text-wrap: nowrap;
`;
